<template>
	<div class="choose-box">
		<div class="icon">
			<slot name="icon"></slot>
		</div>
		<h3><slot name="headline"></slot></h3>
		<p><slot name="text"></slot></p>
	</div>
</template>
<script>
    import Vue from 'vue';
    import SvgIcon from './Svg.vue';
    export default {
    	components:{
			SvgIcon
		},
		data: () => ({
	
		})
	}
</script>